import React from 'react';
import { GamingWidgetImageWrapper, GamingWidgetStyledImage } from './styled-components';
export const GamingWidgetImage = ({ imageUrl }) => {
    return (React.createElement(GamingWidgetImageWrapper, null,
        React.createElement(GamingWidgetStyledImage, { src: imageUrl, draggable: false })));
};
